<template>
  <footer class="footer">
    <button class="tab" :class="{ active: activeTab === 'home' }" @click="goHome"><i class="fa solid fa-house"></i>
      {{ $t("components.chargerresultsfooter.home") }}</button>
    <button class="tab" :class="{ active: activeTab === 'list' }" @click="goToList"><i
        class="fa solid fa-table-list"></i>
      {{ $t("components.chargerresultsfooter.listado") }}</button>
    <button class="tab" :class="{ active: activeTab === 'map' }" @click="goToMap"><i
        class="fa solid fa-map-location"></i>
      {{ $t("components.chargerresultsfooter.mapa") }}</button>
  </footer>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { useIntl } from "@services/i18n/i18nservice";

const router = useRouter();
const intl = useIntl();

// Props para determinar qué tab está activo
defineProps<{
  activeTab?: 'home' | 'list' | 'map';
}>();

function goHome() {
  if (intl?.i18Route) {
    router.push(intl.i18Route({ name: "charge-session-setup" }));
  } else {
    router.push({ name: "charge-session-setup" });
  }
}

function goToList() {
  if (intl?.i18Route) {
    router.push(intl.i18Route({ name: "charger-results" }));
  } else {
    router.push({ name: "charger-results" });
  }
}

function goToMap() {
  if (intl?.i18Route) {
    router.push(intl.i18Route({ name: "charger-results-map" }));
  } else {
    router.push({ name: "charger-results-map" });
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";

.footer {
  border-top: 1px solid var(--border-default-default, #C2CDDD);
  background: var(--background-default-page, #F8FAFD);
  display: flex;
  width: 100%;
  padding: 0;
  justify-content: space-around;
  align-items: center;
  height: 74px;
  position: relative;
  z-index: 2;
}

.tab {
  border: 0;
  background: transparent;
  color: var(--text-default-caption, #667790);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-xs, 8px);
  font-size: var(--font-size-body-sm, 14px);
  cursor: pointer;
  transition: all 0.2s;
  height: 100%;
  font-weight: 900;

  i {
    font-size: var(--icon-size-md, 20px);
  }
}


.active i {
  color: var(--text-primary-default, #D3135A);
}
</style>
